//import { fetchProvider } from './fetch';
import { ENV } from '../environment';
//import { ContentBannerModel } from '../model/content';
import axios from 'axios';
import { ContentBannerModel } from '../model/content';

export const ContentService = (token: string | undefined) => {
  //const fetch = fetchProvider(token, 'autoshipment-central-hub-front');

  const getBanner = async (siteDomain: string, locale: string, bannerId: number, zone: string) =>
    await getData<ContentBannerModel>(
      `${ENV.CONTENT_BFF_URL}/middle-banner/v2/${siteDomain}/${locale}/${bannerId}/${zone}`,
    );

  const getData = async <T>(url: string) => {
    try {
      const data = await axios.request<T>({
        url: url,
        headers: { Accept: 'application/json' },
      });
      return data.data;
    } catch (error: any) {
      return undefined;
    }
  };

  return {
    getBanner,
  };
};
